import Vue from 'vue';
import Vue2TouchEvents from 'vue2-touch-events';
import {
  Login, ChangeTmpPassword, ResetPassword, SelectEnterprise,
} from '@bag-era/cognito-authentication';
import Auth from '@aws-amplify/auth';
import axios from 'axios';
import feather from 'vue-icon';
import App from './App.vue';
import router from './router';
import store from './store';
import './registerServiceWorker';
import i18n from './i18n';

Vue.use(Vue2TouchEvents);

Vue.config.productionTip = false;

//--------------------------------------------------
// Authentication management
//--------------------------------------------------
// eslint-disable-next-line prefer-destructuring
const enterprise = store.getters.enterprise;
if (enterprise) {
  const awsExports = {
    aws_project_region: enterprise.poolInfo.region,
    aws_cognito_region: enterprise.poolInfo.region,
    aws_user_pools_id: enterprise.poolInfo.userPoolId,
    aws_user_pools_web_client_id: enterprise.poolInfo.clientId,
  };
  Auth.configure(awsExports);
}

// Add latest auth access token to every http request
axios.interceptors.request.use(async (config) => {
  if (store.getters.enterprise) {
    try {
      const session = await Auth.currentSession();
      // User is logged in. Set auth header on all requests
      // eslint-disable-next-line no-param-reassign
      config.headers.Authorization = `Bearer ${session.idToken.jwtToken}`;
      if (store.getters.getApiK) {
        const key = store.getters.getApiK;
        // eslint-disable-next-line no-param-reassign
        config.headers['X-api-key'] = key.value;
      }
      return Promise.resolve(config);
    } catch (e) {
      // No logged-in user: don't set auth header - got to login page
      console.log(e);
      store.dispatch('userLogout', null);
      router.push('/login');
    }
  }
  return Promise.resolve(config);
});
//--------------------------------------------------
//                    FILTERS                     //
//--------------------------------------------------

Vue.filter('capitalize', (value) => {
  if (!value) {
    return '';
  }
  const newValue = value.toString();
  return newValue.charAt(0).toUpperCase() + newValue.slice(1);
});

Vue.filter('upper', (value) => {
  if (!value) {
    return '';
  }
  const newValue = value.toString();
  return newValue.toUpperCase();
});

Vue.use(Login, ChangeTmpPassword, ResetPassword, SelectEnterprise);
Vue.use(feather, 'v-icon');
Vue.use(Auth);

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app');
